<template>
	<JBox>
		<!-- Header -->
		<CLayoutEditorHeader
			:isLoading="isLoading"
			headline="Underwriting Logic"
			saveButton="Save"
			@back:click="$router.back()"
			@save:click="saveJsonLogic"
		/>

		<!-- Editor -->
		<JsonLogicEditor v-model="newJsonLogic" />

		<!-- Error Message -->
		<JBox class="s-w-full s-fixed s-bottom-0 s-left-0 s-p-4 s-bg-red-200 s-text-red-700" v-if="errorMessage">
			{{ errorMessage }}
		</JBox>
	</JBox>
</template>

<script>
import JsonLogicEditor from "../components/JsonLogicEditor"
import api from "@/api/api"
import { mutation, query } from "../api/queries"

export default {
	components: { JsonLogicEditor },

	// From router
	props: ["productType", "productPlan", "productVersion"],

	data() {
		return {
			isLoading: false,

			// json logic source
			originalJsonLogic: "",
			newJsonLogic: "",

			// errorMessage
			errorMessage: ""
		}
	},

	computed: {
		productId() {
			return {
				type: this.productType,
				plan: this.productPlan,
				version: this.productVersion ?? null
			}
		},

		hasJsonLogicChanged() {
			return this.originalJsonLogic !== this.newJsonLogic
		}
	},

	methods: {
		async fetchJsonLogic() {
			this.errorMessage = ""
			const variables = { where: { productId: this.productId } }

			this.isLoading = true
			const res = await api({ query: query.underwritingLogic, variables })
			this.isLoading = false

			// Handle errors
			if (!res?.data?.products?.list?.[0]) {
				this.errorMessage = "Oops, there was a problem. Can't fetch jsonLogic"
				this.isLoading = false
				return
			}

			const jsonLogic = res?.data?.products?.list?.[0]?.underwritingRulesJson ?? ""
			this.originalJsonLogic = jsonLogic
			this.newJsonLogic = jsonLogic
		},

		async saveJsonLogic() {
			if (this.isLoading) return //prevent double submit
			this.errorMessage = ""

			const variables = {
				productId: this.productId,
				input: {
					underwritingRules: this.newJsonLogic
				}
			}

			this.isLoading = true
			const res = await api({ query: mutation.updateProduct, variables })
			this.isLoading = false

			if (!res?.data?.updateProduct) {
				this.errorMessage = res?.errors?.[0]?.message ?? "Oops, there was an error"
				return
			}

			this.originalJsonLogic = this.newJsonLogic
		},

		preventBrowserReload(event) {
			event.preventDefault()
			event.returnValue = "Are you sure you want to leave?" // Older browsers supported custom message
			return ""
		}
	},

	mounted() {
		this.fetchJsonLogic()

		// Prevent browser refresh
		window.addEventListener("beforeunload", this.preventBrowserReload)
	},

	beforeDestroy() {
		window.removeEventListener("beforeunload", this.preventBrowserReload)
	},

	// Prevent accidental browser back button
	beforeRouteLeave(to, from, next) {
		// When no change
		if (!this.hasJsonLogicChanged) {
			next()
			return
		}

		const answer = window.confirm("Do you really want to leave? you have unsaved changes!")
		if (answer) next()
		else next(false)
	}
}
</script>
